import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardProps } from '@mui/material';

interface AnimatedCardProps extends CardProps {
  delay?: number;
}

const AnimatedCard: React.FC<AnimatedCardProps> = ({
  children,
  delay = 0,
  sx,
  ...props
}) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-40px' }}
    transition={{ duration: 0.5, delay, ease: 'easeOut' }}
  >
    <Card
      sx={{
        p: 3,
        height: '100%',
        ...sx,
      }}
      {...props}
    >
      {children}
    </Card>
  </motion.div>
);

export default AnimatedCard;
